<div style="display: block">
    <canvas baseChart
                [datasets]="[{data:doughnutChartData}]"
                [labels]="doughnutChartLabels"
                [type]="doughnutChartType"></canvas>
                <a href="#" (click)="downloadCanvas($event)">DOWNLOAD IMAGE</a>
  </div>
